
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"-41 164.9 512 512","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M401.3 378.4c-6.4 0-12.3-4.1-14.3-10.6-23.4-75.8-92.4-126.7-171.8-126.7-54.9 0-106.2 24.7-140.6 67.8-5.2 6.5-14.6 7.5-21.1 2.4-6.5-5.2-7.5-14.6-2.4-21.1 40.1-50.2 99.9-79 164-79 45.7 0 89.2 14.5 125.7 41.8 35.3 26.5 61.8 64.1 74.8 106 2.4 7.9-2 16.3-9.9 18.8-1.4.4-2.9.6-4.4.6z"}}),_c('path',{attrs:{"d":"M358 358.9l51.8 62 27.7-75.9zM215.1 630.6c-45.7 0-89.2-14.5-125.7-41.8-35.3-26.5-61.8-64.1-74.8-106-2.4-7.9 2-16.3 9.9-18.8 7.9-2.4 16.3 2 18.8 9.9 23.4 75.8 92.4 126.7 171.8 126.7 58.8 0 114-28.9 147.7-77.3 4.7-6.8 14.1-8.5 20.9-3.7 6.8 4.7 8.5 14.1 3.7 20.9-39.3 56.4-103.6 90.1-172.3 90.1z"}}),_c('path',{attrs:{"d":"M72.4 482.9l-52.1-62-27.9 75.8z"}}),_c('g',[_c('path',{attrs:{"d":"M213.4 558.1c-75.6 0-137.2-61.5-137.2-137.2s61.5-137.2 137.2-137.2 137.2 61.6 137.2 137.2-61.5 137.2-137.2 137.2zm0-239.4c-56.4 0-102.2 45.7-102.2 102.2s45.7 102.2 102.2 102.2c56.4 0 102.2-45.7 102.2-102.2 0-56.4-45.7-102.1-102.2-102.2z"}}),_c('path',{attrs:{"d":"M206.9 476.6c-21.4-1.9-36.9-13-37.7-33.3h28.6c.6 6.4 3.8 10.4 9.1 12.1v-24.8c-16.8-4.4-37.9-9.1-37.9-33.8 0-19.6 16.5-31.3 37.9-32.7v-12.7h10v12.7c21.5 1.7 35.4 12.7 36.8 32.7H225c-.6-5.8-3.6-9.4-8-11v24.4c16.8 4.7 38.3 9.3 38.3 33.6 0 17-13.5 31.9-38.3 33v12.7h-10l-.1-12.9zm0-69.7V385c-5.8 1-9.4 4.4-9.4 10.5-.1 5.5 3.4 8.8 9.4 11.4zm10 26.7v22.3c6.3-1.1 10.2-5.3 10.2-11.2-.2-5.6-4.2-8.8-10.2-11.1z"}})])])
          )
        }
      }
    